import { Flex, PaperSection } from '@shared/components';

import { EmptyCommentSection, VerdictSubTaskCard } from '../../components';
import { useQSetReviewMainTaskQSet } from '../../providers';

export default function QsetReviewMainTaskViewQuestionReviewResult() {
  const {
    currentVerdict,
    subTasks,
    getCurrentQuestionSubTaskVerdict,
    getCurrentQuestionSubTaskComments,
  } = useQSetReviewMainTaskQSet();
  const isEmpty = currentVerdict.length === 0;
  return (
    <PaperSection title='Review Result'>
      <Flex
        sx={{
          gap: (theme) => theme.spacing(6),
          p: (theme) => theme.spacing(6),

          flexDirection: 'column',
        }}
      >
        {isEmpty ? (
          <EmptyCommentSection />
        ) : (
          subTasks.map((subTask) => (
            <VerdictSubTaskCard
              key={subTask.id}
              subtask={subTask}
              verdict={getCurrentQuestionSubTaskVerdict(subTask.id)}
              comments={getCurrentQuestionSubTaskComments(subTask.id)}
            />
          ))
        )}
      </Flex>
    </PaperSection>
  );
}
